//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RoleClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type RoleGetListRoleQueryParameters = {
  filter?: string | undefined ;
  sorting?: string | undefined ;
  skipCount?: number | undefined ;
  maxResultCount?: number | undefined ;
  extraProperties?: { [key: string]: any; } | undefined ;
}

export type RoleGetRoleQueryParameters = {
  id: string ;
}

export type RoleUpdateRoleQueryParameters = {
  id: string ;
}

export type RoleDeleteRoleQueryParameters = {
  id: string ;
}

export function roleGetAllListUrl(): string {
  let url_ = getBaseUrl() + "/api/identity/roles/all";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let roleGetAllListDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, unknown, Types.ListResultDtoOfIdentityRoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, unknown, Types.ListResultDtoOfIdentityRoleDto>, 'queryFn'>> = {
};
export function getRoleGetAllListDefaultOptions() {
  return roleGetAllListDefaultOptions;
};
export function setRoleGetAllListDefaultOptions(options: typeof roleGetAllListDefaultOptions) {
  roleGetAllListDefaultOptions = options;
}

export function roleGetAllListQueryKey(): QueryKey;
export function roleGetAllListQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'RoleClient',
      'roleGetAllList',
    ]);
}
export function __roleGetAllList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.roleGetAllList(
axiosConfig    );
}

/**
 * @return OK
 */
export function useRoleGetAllListQuery<TSelectData = Types.ListResultDtoOfIdentityRoleDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useRoleGetAllListQuery<TSelectData = Types.ListResultDtoOfIdentityRoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __roleGetAllList(context, axiosConfig) : __roleGetAllList,
    queryKey: roleGetAllListQueryKey(),
    ...roleGetAllListDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setRoleGetAllListData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfIdentityRoleDto | undefined) => Types.ListResultDtoOfIdentityRoleDto, ) {
  queryClient.setQueryData(roleGetAllListQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setRoleGetAllListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfIdentityRoleDto | undefined) => Types.ListResultDtoOfIdentityRoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function roleGetListUrl(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined): string {
  let url_ = getBaseUrl() + "/api/identity/roles?";
if (filter === null)
    throw new Error("The parameter 'filter' cannot be null.");
else if (filter !== undefined)
    url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
if (sorting === null)
    throw new Error("The parameter 'sorting' cannot be null.");
else if (sorting !== undefined)
    url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
if (skipCount === null)
    throw new Error("The parameter 'skipCount' cannot be null.");
else if (skipCount !== undefined)
    url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
if (extraProperties === null)
    throw new Error("The parameter 'extraProperties' cannot be null.");
else if (extraProperties !== undefined)
    extraProperties && Object.keys(extraProperties).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + extraProperties[key]) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let roleGetListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityRoleDto, unknown, Types.PagedResultDtoOfIdentityRoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultDtoOfIdentityRoleDto, unknown, Types.PagedResultDtoOfIdentityRoleDto>, 'queryFn'>> = {
};
export function getRoleGetListDefaultOptions() {
  return roleGetListDefaultOptions;
};
export function setRoleGetListDefaultOptions(options: typeof roleGetListDefaultOptions) {
  roleGetListDefaultOptions = options;
}

export function roleGetListQueryKey(dto: RoleGetListRoleQueryParameters): QueryKey;
export function roleGetListQueryKey(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined): QueryKey;
export function roleGetListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { filter, sorting, skipCount, maxResultCount, extraProperties,  } = params[0] as RoleGetListRoleQueryParameters;

    return trimArrayEnd([
        'RoleClient',
        'roleGetList',
        filter as any,
        sorting as any,
        skipCount as any,
        maxResultCount as any,
        extraProperties as any,
      ]);
  } else {
    return trimArrayEnd([
        'RoleClient',
        'roleGetList',
        ...params
      ]);
  }
}
export function __roleGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.roleGetList(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as number | undefined,       context.queryKey[6] as { [key: string]: any; } | undefined,axiosConfig    );
}

export function useRoleGetListQuery<TSelectData = Types.PagedResultDtoOfIdentityRoleDto, TError = unknown>(dto: RoleGetListRoleQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @param extraProperties (optional) 
 * @return OK
 */
export function useRoleGetListQuery<TSelectData = Types.PagedResultDtoOfIdentityRoleDto, TError = unknown>(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useRoleGetListQuery<TSelectData = Types.PagedResultDtoOfIdentityRoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultDtoOfIdentityRoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let filter: any = undefined;
  let sorting: any = undefined;
  let skipCount: any = undefined;
  let maxResultCount: any = undefined;
  let extraProperties: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ filter, sorting, skipCount, maxResultCount, extraProperties,  } = params[0] as RoleGetListRoleQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [filter, sorting, skipCount, maxResultCount, extraProperties, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultDtoOfIdentityRoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __roleGetList(context, axiosConfig) : __roleGetList,
    queryKey: roleGetListQueryKey(filter, sorting, skipCount, maxResultCount, extraProperties),
    ...roleGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @param extraProperties (optional) 
 * @return OK
 */
export function setRoleGetListData(queryClient: QueryClient, updater: (data: Types.PagedResultDtoOfIdentityRoleDto | undefined) => Types.PagedResultDtoOfIdentityRoleDto, filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined) {
  queryClient.setQueryData(roleGetListQueryKey(filter, sorting, skipCount, maxResultCount, extraProperties),
    updater
  );
}

/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @param extraProperties (optional) 
 * @return OK
 */
export function setRoleGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultDtoOfIdentityRoleDto | undefined) => Types.PagedResultDtoOfIdentityRoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function roleCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/identity/roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function roleCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'RoleClient',
      'roleCreate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useRoleCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.IdentityRoleDto, unknown, Types.IdentityRoleCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IdentityRoleDto, unknown, Types.IdentityRoleCreateDto, TContext> {
  const key = roleCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.IdentityRoleCreateDto) => Client.roleCreate(body),
    mutationKey: key,
  });
}
  
export function roleGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let roleGetDefaultOptions: Omit<UseQueryOptions<Types.IdentityRoleDto, unknown, Types.IdentityRoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.IdentityRoleDto, unknown, Types.IdentityRoleDto>, 'queryFn'>> = {
};
export function getRoleGetDefaultOptions() {
  return roleGetDefaultOptions;
};
export function setRoleGetDefaultOptions(options: typeof roleGetDefaultOptions) {
  roleGetDefaultOptions = options;
}

export function roleGetQueryKey(id: string): QueryKey;
export function roleGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as RoleGetRoleQueryParameters;

    return trimArrayEnd([
        'RoleClient',
        'roleGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'RoleClient',
        'roleGet',
        ...params
      ]);
  }
}
export function __roleGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.roleGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function useRoleGetQuery<TSelectData = Types.IdentityRoleDto, TError = unknown>(dto: RoleGetRoleQueryParameters, options?: Omit<UseQueryOptions<Types.IdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useRoleGetQuery<TSelectData = Types.IdentityRoleDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.IdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useRoleGetQuery<TSelectData = Types.IdentityRoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IdentityRoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as RoleGetRoleQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.IdentityRoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __roleGet(context, axiosConfig) : __roleGet,
    queryKey: roleGetQueryKey(id),
    ...roleGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.IdentityRoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setRoleGetData(queryClient: QueryClient, updater: (data: Types.IdentityRoleDto | undefined) => Types.IdentityRoleDto, id: string) {
  queryClient.setQueryData(roleGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setRoleGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IdentityRoleDto | undefined) => Types.IdentityRoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function roleUpdateUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function roleUpdateMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'RoleClient',
      'roleUpdate',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useRoleUpdateMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.IdentityRoleDto, unknown, Types.IdentityRoleUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IdentityRoleDto, unknown, Types.IdentityRoleUpdateDto, TContext> {
  const key = roleUpdateMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.IdentityRoleUpdateDto) => Client.roleUpdate(id, body),
    mutationKey: key,
  });
}
  
type RoleUpdate__MutationParameters = RoleUpdateRoleQueryParameters & {
  body: Types.IdentityRoleUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useRoleUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.IdentityRoleDto, unknown, RoleUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RoleUpdateRoleQueryParameters}): UseMutationResult<Types.IdentityRoleDto, unknown, RoleUpdate__MutationParameters, TContext> {
  const key = roleUpdateMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RoleUpdate__MutationParameters) => Client.roleUpdate(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function roleDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function roleDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'RoleClient',
      'roleDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useRoleDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = roleDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.roleDelete(id),
    mutationKey: key,
  });
}
  
type RoleDelete__MutationParameters = RoleDeleteRoleQueryParameters

/**
 * @return OK
 */
export function useRoleDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RoleDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RoleDeleteRoleQueryParameters}): UseMutationResult<void, unknown, RoleDelete__MutationParameters, TContext> {
  const key = roleDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RoleDelete__MutationParameters) => Client.roleDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}